import { Map } from 'immutable';
import { actionTypes } from './actions';
import configObjectTypes from '../../../../constants/configObjectTypes';

const initialState = Map({
  loading: false,
  [configObjectTypes.link]: null,
  [configObjectTypes.modal]: null,
  [configObjectTypes.bankImg]: null,
  [configObjectTypes.situations]: null,
  error: null,
});

export default function adminConfigReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS: {
      const { data, type } = action.payload;
      return state.set('loading', false).set(type, data).set('error', null);
    }
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}
